(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["certificate-ISTT"] && !Shopify.designMode) return;
  try {
    
(function() {
  'use strict';

  var pdp = document.querySelector('.cert-pdp');
  if (!pdp) return;

  /* ---------- Bio lightbox ---------- */
  var lightbox = pdp.querySelector('.cert-lightbox');
  var photoEl = lightbox.querySelector('[id^="cert-lightbox-photo"]');
  var nameEl = lightbox.querySelector('[id^="cert-lightbox-name"]');
  var roleEl = lightbox.querySelector('[id^="cert-lightbox-role"]');
  var bodyEl = lightbox.querySelector('[id^="cert-lightbox-body"]');

  function openBio(trigger) {
    nameEl.textContent = trigger.dataset.bioName || '';
    var role = trigger.dataset.bioTitle || '';
    roleEl.textContent = role;
    roleEl.style.display = role ? '' : 'none';
    bodyEl.innerHTML = trigger.dataset.bioBody || '<p>Bio coming soon.</p>';
    var photo = trigger.dataset.bioPhoto || '';
    if (photo) { photoEl.style.backgroundImage = 'url(' + photo + ')'; photoEl.style.display = ''; }
    else { photoEl.style.display = 'none'; }
    lightbox.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeBio() { lightbox.classList.remove('is-open'); document.body.style.overflow = ''; }

  pdp.addEventListener('click', function(e) {
    var trigger = e.target.closest('[data-bio-trigger]');
    if (trigger) { openBio(trigger); return; }
    if (e.target.closest('[data-lightbox-close]')) { closeBio(); return; }
  });
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && lightbox.classList.contains('is-open')) closeBio();
  });

  /* ---------- Smooth-scroll for in-page anchors ---------- */
  var navLinks = pdp.querySelectorAll('.cert-subnav a[href^="#"], .cert-subnav__cta-floating[href^="#"], .cert-hero a[href^="#"], .cert-istt-why a[href^="#"]');
  navLinks.forEach(function(link) {
    link.addEventListener('click', function(e) {
      var id = link.getAttribute('href');
      if (id.length < 2) return;
      var target = document.querySelector(id);
      if (!target) return;
      e.preventDefault();
      var subnav = pdp.querySelector('.cert-subnav');
      var subnavHeight = subnav ? subnav.offsetHeight : 0;
      var headerOffset = parseInt(getComputedStyle(pdp).getPropertyValue('--tel-header-offset')) || 71;
      var totalOffset = subnavHeight + headerOffset;
      var y = target.getBoundingClientRect().top + window.pageYOffset - totalOffset - 16;
      window.scrollTo({ top: y, behavior: 'smooth' });
    });
  });

  /* ---------- Active subnav link on scroll (mobile horizontal nav) ---------- */
  var subnavLinks = pdp.querySelectorAll('.cert-subnav__links [data-nav-link]');
  var subnavSections = [];
  subnavLinks.forEach(function(link) {
    var section = document.querySelector(link.getAttribute('href'));
    if (section) subnavSections.push({ link: link, section: section });
  });
  if (subnavSections.length) {
    var subnavLinksEl = pdp.querySelector('.cert-subnav__links');
    var setActiveSubnavLink = function() {
      var current = null;
      subnavSections.forEach(function(item) {
        var rect = item.section.getBoundingClientRect();
        if (rect.top <= 180 && rect.bottom >= 180) current = item;
      });
      subnavLinks.forEach(function(link) { link.classList.remove('is-active'); });
      if (current) {
        current.link.classList.add('is-active');
        if (subnavLinksEl) current.link.scrollIntoView({ inline: 'center', block: 'nearest' });
      }
    };
    setActiveSubnavLink();
    window.addEventListener('scroll', setActiveSubnavLink, { passive: true });
  }

  var attempts = 0;
  var hydrateInterval = setInterval(function(){
    attempts++;
    if (hydrateLoopPrices() || attempts > 20) {
      clearInterval(hydrateInterval);
    }
  }, 300);

  setTimeout(syncSellingPlan, 1500);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["certificate-pdp-coming-soon"] && !Shopify.designMode) return;
  try {
    
(function() {
  'use strict';
  var pdp = document.querySelector('.cert-pdp');
  if (!pdp) return;

  var lightbox = pdp.querySelector('.cert-lightbox');
  var photoEl = lightbox.querySelector('[id^="cert-lightbox-photo"]');
  var nameEl = lightbox.querySelector('[id^="cert-lightbox-name"]');
  var roleEl = lightbox.querySelector('[id^="cert-lightbox-role"]');
  var bodyEl = lightbox.querySelector('[id^="cert-lightbox-body"]');

  function openBio(trigger) {
    nameEl.textContent = trigger.dataset.bioName || '';
    var role = trigger.dataset.bioTitle || '';
    roleEl.textContent = role;
    roleEl.style.display = role ? '' : 'none';
    bodyEl.innerHTML = trigger.dataset.bioBody || '<p>Bio coming soon.</p>';
    var photo = trigger.dataset.bioPhoto || '';
    if (photo) {
      photoEl.style.backgroundImage = 'url(' + photo + ')';
      photoEl.style.display = '';
    } else {
      photoEl.style.display = 'none';
    }
    lightbox.classList.add('is-open');
    lightbox.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeBio() {
    lightbox.classList.remove('is-open');
    lightbox.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  pdp.addEventListener('click', function(e) {
    var trigger = e.target.closest('[data-bio-trigger]');
    if (trigger) { openBio(trigger); return; }
    if (e.target.closest('[data-lightbox-close]')) { closeBio(); return; }
  });

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && lightbox.classList.contains('is-open')) closeBio();
  });

  var navLinks = pdp.querySelectorAll('.cert-subnav a[href^="#"], .cert-hero a[href^="#"], .cert-about a[href^="#"]');
  navLinks.forEach(function(link) {
    link.addEventListener('click', function(e) {
      var id = link.getAttribute('href');
      if (id.length < 2) return;
      var target = document.querySelector(id);
      if (!target) return;
      e.preventDefault();
      var subnav = pdp.querySelector('.cert-subnav');
      var subnavHeight = subnav ? subnav.offsetHeight : 0;
      var headerOffset = parseInt(getComputedStyle(pdp).getPropertyValue('--tel-header-offset')) || 80;
      var totalOffset = subnavHeight + headerOffset;
      var y = target.getBoundingClientRect().top + window.pageYOffset - totalOffset - 16;
      window.scrollTo({ top: y, behavior: 'smooth' });
    });
  });

  var sections = pdp.querySelectorAll('section[id]');
  var subnavLinks = pdp.querySelectorAll('.cert-subnav__links a');
  if ('IntersectionObserver' in window && sections.length && subnavLinks.length) {
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          var id = entry.target.getAttribute('id');
          subnavLinks.forEach(function(link) {
            link.style.color = '';
            link.style.borderBottomColor = '';
            if (link.getAttribute('href') === '#' + id) {
              link.style.color = 'var(--tel-gold-bright)';
              link.style.borderBottomColor = 'var(--tel-gold-bright)';
            }
          });
        }
      });
    }, { rootMargin: '-20% 0px -70% 0px' });
    sections.forEach(function(s) { observer.observe(s); });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["certificate-pdp-loop-grief"] && !Shopify.designMode) return;
  try {
    
(function() {
  'use strict';

  var pdp = document.querySelector('.cert-pdp');
  if (!pdp) return;

    /* ---------- Collapse accordions visually after load (content stays in DOM open-by-default) ---------- */
function collapseAccordionsOnLoad() {
  if (window.Shopify && Shopify.designMode) return; // keep everything open in Theme Editor

  // Curriculum: keep only the first module open, matching original UX
  var curriculumItems = pdp.querySelectorAll('details[data-accordion-group="curriculum"]');
  curriculumItems.forEach(function(d, i) {
    if (i > 0) d.removeAttribute('open');
  });

  // Timestamps and FAQ: originally closed by default
  var closedByDefault = pdp.querySelectorAll('details[data-accordion-group="timestamps"], details[data-accordion-group="faq"]');
  closedByDefault.forEach(function(d) { d.removeAttribute('open'); });
}
collapseAccordionsOnLoad();

  /* ---------- Bio lightbox ---------- */
  var lightbox = pdp.querySelector('.cert-lightbox');
  var photoEl = lightbox.querySelector('[id^="cert-lightbox-photo"]');
  var nameEl = lightbox.querySelector('[id^="cert-lightbox-name"]');
  var roleEl = lightbox.querySelector('[id^="cert-lightbox-role"]');
  var bodyEl = lightbox.querySelector('[id^="cert-lightbox-body"]');

  /* ---------- Grief rich text cards ---------- */
  function isCardHeading(node) {
    return node && node.nodeType === 1 && /^(H2|H3|H4)$/.test(node.tagName);
  }

  function enhanceGriefRichText(container) {
    if (!container || container.classList.contains('is-enhanced')) return;
    var source = container.querySelector('.metafield-rich_text_field') || container;
    var hasHeading = Array.from(source.children).some(isCardHeading);
    if (!hasHeading) return;

    var prefix = container.getAttribute('data-grief-cardize') === 'pathways'
      ? 'cert-grief-pathways'
      : 'cert-grief-why';

    var intro = document.createElement('div');
    intro.className = prefix + '__intro';
    while (source.firstChild && !isCardHeading(source.firstChild)) {
      intro.appendChild(source.firstChild);
    }
    if (intro.textContent.trim()) {
      source.parentNode.insertBefore(intro, source);
    }

    var cards = document.createElement('div');
    cards.className = prefix + '__cards';
    while (source.firstChild) {
      if (!isCardHeading(source.firstChild)) {
        source.removeChild(source.firstChild);
        continue;
      }
      var card = document.createElement('article');
      card.className = prefix + '__card';
      card.appendChild(source.firstChild);
      while (source.firstChild && !isCardHeading(source.firstChild)) {
        card.appendChild(source.firstChild);
      }
      cards.appendChild(card);
    }
    source.appendChild(cards);
    container.classList.add('is-enhanced');
  }

  pdp.querySelectorAll('[data-grief-cardize]').forEach(enhanceGriefRichText);

  /* ---------- Pathway card meta extraction (Tool + Faculty) ---------- */
  function decodeHtmlEntities(s) {
    var d = document.createElement('div');
    d.innerHTML = s;
    return (d.textContent || '').replace(/\s+/g, ' ').trim();
  }

  function appendPathwayMetaRow(meta, label, value) {
    if (!value) return;
    var row = document.createElement('div');
    row.className = 'cert-grief-pathways__card-meta-row';
    var lab = document.createElement('span');
    lab.className = 'cert-grief-pathways__card-meta-label';
    lab.textContent = label;
    var val = document.createElement('span');
    val.className = 'cert-grief-pathways__card-meta-value';
    val.textContent = value;
    row.appendChild(lab);
    row.appendChild(val);
    meta.appendChild(row);
  }

  function structurePathwayCards() {
    pdp.querySelectorAll('.cert-grief-pathways__card').forEach(function(card) {
      if (card.dataset.metaExtracted === '1') return;
      card.dataset.metaExtracted = '1';

      var paragraphs = Array.from(card.querySelectorAll('p'));
      if (!paragraphs.length) return;

      // Find the LAST paragraph containing "Tool:" and extract from it.
      // Use textContent so inline tags (<strong>, <em>) wrapping "Tool:" don't block the match.
      // Greedy regex captures the FINAL "Tool:" in the paragraph (avoids false positives
      // on the lowercase word "tool" appearing earlier in the description).
      var toolRaw = null;
      for (var i = paragraphs.length - 1; i >= 0; i--) {
        var p = paragraphs[i];
        var text = (p.textContent || '').replace(/ /g, ' ');
        var m = text.match(/^([\s\S]*)\bTool\s*[:—–]\s*(.+?)\s*$/i);
        if (m) {
          toolRaw = m[2].replace(/\\$/, '').trim();
          // Strip a trailing duplicate "Tool:" from the before content (handles
          // metafield typos like "Tool: Tool: X").
          var before = m[1]
            .replace(/\bTool\s*[:—–]\s*$/i, '')
            .replace(/[\s ]+$/, '');
          if (before) {
            p.textContent = before;
          } else {
            p.remove();
          }
          break;
        }
      }

      if (!toolRaw) return;

      // Split "X · Faculty Y",  separators · •,  –
      var parts = toolRaw.split(/\s*[·•—–]\s*/);
      var tool = (parts.shift() || '').trim();
      var facultyRaw = parts.join(' · ').trim();
      // Faculty names may be separated by "/" in the source,  display with · instead.
      var faculty = facultyRaw.split(/\s*\/\s*/).filter(Boolean).join(' · ');

      var meta = document.createElement('div');
      meta.className = 'cert-grief-pathways__card-meta';
      appendPathwayMetaRow(meta, 'Tool', tool);
      appendPathwayMetaRow(meta, 'Faculty', faculty);
      card.appendChild(meta);
    });
  }

  structurePathwayCards();



  function openBio(trigger) {
  nameEl.textContent = trigger.dataset.bioName || '';
  var role = trigger.dataset.bioTitle || '';
  roleEl.textContent = role;
  roleEl.style.display = role ? '' : 'none';
  var targetId = trigger.dataset.bioTarget;
  var sourceEl = targetId ? document.getElementById(targetId) : null;
  bodyEl.innerHTML = sourceEl ? sourceEl.innerHTML : '<p>Bio coming soon.</p>';
  var photo = trigger.dataset.bioPhoto || '';
  if (photo) { photoEl.style.backgroundImage = 'url(' + photo + ')'; photoEl.style.display = ''; }
  else { photoEl.style.display = 'none'; }
  lightbox.classList.add('is-open');
  document.body.style.overflow = 'hidden';
}
  function closeBio() { lightbox.classList.remove('is-open'); document.body.style.overflow = ''; }

  pdp.addEventListener('click', function(e) {
    var trigger = e.target.closest('[data-bio-trigger]');
    if (trigger) { openBio(trigger); return; }
    if (e.target.closest('[data-lightbox-close]')) { closeBio(); return; }
  });
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && lightbox.classList.contains('is-open')) closeBio();
  });

  /* ---------- Smooth-scroll for in-page anchors ---------- */
  var navLinks = pdp.querySelectorAll('.cert-subnav a[href^="#"], .cert-hero a[href^="#"], .cert-about a[href^="#"], .cert-grief-why a[href^="#"]');
  navLinks.forEach(function(link) {
    link.addEventListener('click', function(e) {
      var id = link.getAttribute('href');
      if (id.length < 2) return;
      var target = document.querySelector(id);
      if (!target) return;
      e.preventDefault();
      var subnav = pdp.querySelector('.cert-subnav');
      var subnavHeight = subnav ? subnav.offsetHeight : 0;
      var headerOffset = parseInt(getComputedStyle(pdp).getPropertyValue('--tel-header-offset')) || 71;
      var totalOffset = subnavHeight + headerOffset;
      var y = target.getBoundingClientRect().top + window.pageYOffset - totalOffset - 16;
      window.scrollTo({ top: y, behavior: 'smooth' });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["certificate-polyvagal"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';
    var pdp = document.querySelector('.cert-pdp');
    if (!pdp) return;

    var lightbox = pdp.querySelector('.cert-lightbox');
    var photoEl = lightbox.querySelector('[id^="cert-lightbox-photo"]');
    var nameEl = lightbox.querySelector('[id^="cert-lightbox-name"]');
    var roleEl = lightbox.querySelector('[id^="cert-lightbox-role"]');
    var bodyEl = lightbox.querySelector('[id^="cert-lightbox-body"]');

    function openBio(trigger) {
      nameEl.textContent = trigger.dataset.bioName || '';
      var role = trigger.dataset.bioTitle || '';
      roleEl.textContent = role;
      roleEl.style.display = role ? '' : 'none';
      bodyEl.innerHTML = trigger.dataset.bioBody || '<p>Bio coming soon.</p>';
      var photo = trigger.dataset.bioPhoto || '';
      if (photo) {
        photoEl.style.backgroundImage = 'url(' + photo + ')';
        photoEl.style.display = '';
      } else {
        photoEl.style.display = 'none';
      }
      lightbox.classList.add('is-open');
      lightbox.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function closeBio() {
      lightbox.classList.remove('is-open');
      lightbox.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    pdp.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-bio-trigger]');
      if (trigger) {
        openBio(trigger);
        return;
      }
      if (e.target.closest('[data-lightbox-close]')) {
        closeBio();
        return;
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && lightbox.classList.contains('is-open')) closeBio();
    });

    var navLinks = pdp.querySelectorAll('.cert-subnav a[href^="#"], .cert-hero a[href^="#"], .cert-about a[href^="#"]');
    navLinks.forEach(function (link) {
      link.addEventListener('click', function (e) {
        var id = link.getAttribute('href');
        if (id.length < 2) return;
        var target = document.querySelector(id);
        if (!target) return;
        e.preventDefault();
        var subnav = pdp.querySelector('.cert-subnav');
        var subnavHeight = subnav ? subnav.offsetHeight : 0;
        var headerOffset = parseInt(getComputedStyle(pdp).getPropertyValue('--tel-header-offset')) || 80;
        var totalOffset = subnavHeight + headerOffset;
        var y = target.getBoundingClientRect().top + window.pageYOffset - totalOffset - 16;
        window.scrollTo({ top: y, behavior: 'smooth' });
      });
    });

    var sections = pdp.querySelectorAll('section[id]');
    var subnavLinks = pdp.querySelectorAll('.cert-subnav__links a');
    if ('IntersectionObserver' in window && sections.length && subnavLinks.length) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              var id = entry.target.getAttribute('id');
              subnavLinks.forEach(function (link) {
                link.style.color = '';
                link.style.borderBottomColor = '';
                if (link.getAttribute('href') === '#' + id) {
                  link.style.color = 'var(--tel-gold-bright)';
                  link.style.borderBottomColor = 'var(--tel-gold-bright)';
                }
              });
            }
          });
        },
        { rootMargin: '-20% 0px -70% 0px' }
      );
      sections.forEach(function (s) {
        observer.observe(s);
      });
    }
    var wylTabs = pdp.querySelectorAll('.wyl-tab');
    var wylPanels = pdp.querySelectorAll('.wyl-panel');
    if (wylTabs.length && wylPanels.length) {
      wylTabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var target = tab.getAttribute('data-wyl-tab');
          wylTabs.forEach(function (t) {
            t.classList.remove('is-active');
            t.setAttribute('aria-selected', 'false');
          });
          tab.classList.add('is-active');
          tab.setAttribute('aria-selected', 'true');
          wylPanels.forEach(function (panel) {
            if (panel.getAttribute('data-wyl-panel') === target) {
              panel.classList.add('is-active');
              panel.removeAttribute('hidden');
            } else {
              panel.classList.remove('is-active');
              panel.setAttribute('hidden', '');
            }
          });
        });
        tab.addEventListener('keydown', function (e) {
          if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
          e.preventDefault();
          var tabs = Array.prototype.slice.call(wylTabs);
          var idx = tabs.indexOf(tab);
          var nextIdx = e.key === 'ArrowRight' ? (idx + 1) % tabs.length : (idx - 1 + tabs.length) % tabs.length;
          tabs[nextIdx].focus();
          tabs[nextIdx].click();
        });
      });
    }

    /* ===== Hero Buy Box variant selector ===== */
    /* ===== Hero Buy Box variant selector ===== */
    pdp.querySelectorAll('[data-tel-buybox]').forEach(function (buybox) {
      var tiles = buybox.querySelectorAll('[data-tel-tile]');
      var hidden = buybox.querySelector('[data-tel-variant-id]');
      tiles.forEach(function (tile) {
        tile.addEventListener('click', function () {
          tiles.forEach(function (t) {
            t.classList.remove('is-selected');
          });
          tile.classList.add('is-selected');
          var input = tile.querySelector('input[type="radio"]');
          if (input) input.checked = true;
          if (hidden) hidden.value = tile.getAttribute('data-variant-id');
        });
      });
    });

    /* Intercepta o submit de qualquer form pra /cart/add (buybox + enrollment cards),
       faz fetch em vez de navegar pro /cart, e abre o mini cart drawer no sucesso.
       NÃO altera nenhuma tag/classe existente. */
    pdp.querySelectorAll('form[action="/cart/add"]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var submitBtn = form.querySelector('[type="submit"]');
        if (submitBtn) submitBtn.disabled = true;

        var formData = new FormData(form);

        fetch('/cart/add.js', {
          method: 'POST',
          body: formData
        })
          .then(function (response) {
            if (!response.ok) throw new Error('HTTP error! Status: ' + response.status);
            return response.json();
          })
          .then(function () {
            document.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true, cancelable: false }));
            document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open'));
          })
          .catch(function (error) {
            console.log(error); // eslint-disable-line
          })
          .finally(function () {
            if (submitBtn) submitBtn.disabled = false;
          });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class MobileDisclosure extends DetailsDisclosure {
      constructor() {
        super();

        const collapseEnabled = this.dataset.collapse === 'true';
        if (!collapseEnabled) return;

        this.reset();
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
          this.querySelectorAll('.disclosure, .disclosure__title, .disclosure__panel, .disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(`mobile-${cl}`);
            });
          });
        } else {
          this.toggle.removeAttribute('tabindex');
          this.querySelectorAll('.mobile-disclosure, .mobile-disclosure__title, .mobile-disclosure__panel, .mobile-disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('mobile-disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(cl.substr(7));
            });
          });
        }
      }
    }

    customElements.define('mobile-disclosure', MobileDisclosure);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["istt-faq-refactor"] && !Shopify.designMode) return;
  try {
    
(function() {
  document.querySelectorAll('[data-faq-item]').forEach(function(item, idx) {
    if (idx > 0) item.removeAttribute('open');
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["istt-preview-landing-old"] && !Shopify.designMode) return;
  try {
    
(function() {
  function pad(n) { return String(n).padStart(2, '0'); }

  function tick() {
    document.querySelectorAll('[data-istt-countdown]').forEach(function(el) {
      var target = new Date(el.dataset.target).getTime();
      var now = Date.now();
      var s = Math.max(0, Math.floor((target - now) / 1000));
      var days = Math.floor(s / 86400);
      var hours = Math.floor((s % 86400) / 3600);
      var mins = Math.floor((s % 3600) / 60);
      var secs = s % 60;
      var vals = { days: pad(days), hours: pad(hours), mins: pad(mins), secs: pad(secs) };
      el.querySelectorAll('[data-cd]').forEach(function(span) {
        span.textContent = vals[span.dataset.cd];
      });
    });
  }
  tick();
  setInterval(tick, 1000);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["istt-v2-curriculum"] && !Shopify.designMode) return;
  try {
    
(function() {
  var panels = document.querySelectorAll('[data-curric-panel]');
  var thumbs = document.querySelectorAll('[data-pillar-thumb]');

  panels.forEach(function(panel) {
    var summary = panel.querySelector('summary');
    summary.addEventListener('click', function(e) {
      e.preventDefault();
      var isOpen = panel.hasAttribute('open');
      panels.forEach(function(p) { p.removeAttribute('open'); });
      thumbs.forEach(function(t) { t.removeAttribute('data-active'); });
      if (!isOpen) {
        panel.setAttribute('open', '');
        var matchingThumb = document.querySelector('[data-target="' + panel.id + '"]');
        if (matchingThumb) matchingThumb.setAttribute('data-active', '');
      }
    });
  });

  thumbs.forEach(function(thumb) {
    thumb.addEventListener('click', function() {
      var target = document.getElementById(thumb.dataset.target);
      panels.forEach(function(p) { p.removeAttribute('open'); });
      thumbs.forEach(function(t) { t.removeAttribute('data-active'); });
      if (target) {
        target.setAttribute('open', '');
        target.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
      thumb.setAttribute('data-active', '');
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["istt-v2-faq"] && !Shopify.designMode) return;
  try {
    
(function() {
  document.querySelectorAll('[data-faq-item]').forEach(function(item, idx) {
    if (idx > 0) item.removeAttribute('open');
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["istt-v2-hero"] && !Shopify.designMode) return;
  try {
    
(function() {
  document.querySelectorAll('[data-istt2-quote-carousel]').forEach(function(carousel) {
    var slides = carousel.querySelectorAll('.istt2-hero__quote-slide');
    var dots = carousel.querySelectorAll('[data-istt2-dot]');
    var current = 0;
    function show(i) {
      slides.forEach(function(s, idx) { s.hidden = idx !== i; });
      dots.forEach(function(d, idx) { if (idx === i) { d.setAttribute('data-active', ''); } else { d.removeAttribute('data-active'); } });
      current = i;
    }
    dots.forEach(function(dot, i) {
      dot.addEventListener('click', function() { show(i); });
    });
    if (slides.length > 1) {
      setInterval(function() { show((current + 1) % slides.length); }, 6000);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mba-videos-faq"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-mba-videos-faq-item]').forEach(function (item, idx) {
    if (idx > 0) item.removeAttribute('open');
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
